import React from 'react';
import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';

// Phase 7: shared star-rating display, used both read-only (venue cards,
// review lists) and interactive (the "rate this venue" picker in
// MyBookings.jsx) so the two never drift visually.
export function StarRating({ value = 0, size = 14, interactive = false, onChange, testIdPrefix }) {
  const rounded = Math.round(value);
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          size={size}
          data-testid={testIdPrefix ? `${testIdPrefix}-${n}` : undefined}
          onClick={interactive ? () => onChange?.(n) : undefined}
          className={cn(
            n <= rounded ? 'fill-volt text-volt' : 'text-white/20',
            interactive && 'cursor-pointer hover:scale-110 transition-transform',
          )}
        />
      ))}
    </div>
  );
}

export default StarRating;
